import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CREATE_BLOCK_DATE, CREATE_BLOCK_DATE_SUCCESS, CREATE_BLOCK_DATE_ERROR } from '../../actions';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* createBlockDateGolfPricing({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/golf-inventory/block-date/create`,
      method: 'POST',
      data: payload?.data,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: CREATE_BLOCK_DATE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_BLOCK_DATE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_BLOCK_DATE_ERROR, payload: error });
  }
}

export function* watchcreateBlockDateGolfPricing() {
  yield takeEvery(CREATE_BLOCK_DATE, createBlockDateGolfPricing);
}

function* createBlockDateGolfPricingSaga() {
  yield all([fork(watchcreateBlockDateGolfPricing)]);
}

export default createBlockDateGolfPricingSaga;
